module.exports = __webpack_public_path__ + "img/nowater.cac41170.svg";